<template>
  <div>
    <div class="box ver">
      <vue-markdown :source="content"></vue-markdown>
      <!--<div v-html="content" style="white-space: pre-line"></div>-->
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: "office-version",
  components: {
    VueMarkdown
  },
  data () {
    return {
      content: ''
    }
  },
  created () {
    this.getData();
  },
  methods: {
    getData () {
      this.$axios.get('admin/launchpack/service/office/version_log').then(res => {
        this.content = res.data;
      })
    }
  }
}
</script>

<style lang="stylus">
  .ver
    h1
    h2
    h3
      font-weight bold
      margin-top 4px
    h1
      font-size 20px
    h2
      font-size 17px
    h3
      font-size 15px
      margin-top 20px
    ul
      padding-left 20px
      li
        list-style disc
    ol
      padding-left 28px
      margin-bottom 8px
</style>
